var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcon4Square = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080",
    transform: "translate(0 0.147)",
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_588",
    "data-name": "Rectangle 588",
    transform: "translate(0 -0.147)",
    fill: "#fff",
    stroke: "#1b246a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_588-2",
    "data-name": "Rectangle 588",
    transform: "translate(12 -0.147)",
    fill: "#fff",
    stroke: "#1b246a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_588-3",
    "data-name": "Rectangle 588",
    transform: "translate(0 11.853)",
    fill: "#fff",
    stroke: "#1b246a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_588-4",
    "data-name": "Rectangle 588",
    transform: "translate(12 11.853)",
    fill: "#fff",
    stroke: "#1b246a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    fill: "none"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon4Square, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-4-square.f2f3546b.svg";
export { ForwardRef as ReactComponent };